<ion-content>
  <div class="no-page">
    <div class="ion-text-center">
      <p>Sorry, the page you are looking for is not available!</p>
      <ion-button (click)="onGoBack()" size="small">Go Back</ion-button>
    </div>

  </div>
</ion-content>
